import { Placement } from "react-aria";

export * as COLORS from "./colors";

export * from "./palettes";

export const THEMES = {
  DARK: "dark",
  CUSTOM_DARK: "custom-dark",
  LIGHT: "light",
} as const;

export type Theme = (typeof THEMES)[keyof typeof THEMES];

export const placements: Placement[] = [
  "bottom",
  "bottom left",
  "bottom right",
  "bottom start",
  "bottom end",
  "top",
  "top left",
  "top right",
  "top start",
  "top end",
  "left",
  "left top",
  "left bottom",
  "start",
  "start top",
  "start bottom",
  "right",
  "right top",
  "right bottom",
  "end",
  "end top",
  "end bottom",
];

export const BREAKPOINTS = {
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 992,
  X_LARGE: 1200,
};

export type Breakpoint = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];
